import { render, staticRenderFns } from "./countLoancountOrder.vue?vue&type=template&id=bcf6dc96&scoped=true"
import script from "./countLoancountOrder.vue?vue&type=script&lang=js"
export * from "./countLoancountOrder.vue?vue&type=script&lang=js"
import style0 from "./countLoancountOrder.vue?vue&type=style&index=0&id=bcf6dc96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf6dc96",
  null
  
)

export default component.exports